import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Form,
  Modal,
  Row,
  Col,
  Badge,
  ListGroup,
  InputGroup,
  Spinner,
  Dropdown,
} from "react-bootstrap";
import ReactPaginate from "react-paginate";
import Swal from "sweetalert2";
import Cookies from "universal-cookie";
import {
  FiEdit,
  FiTrash,
  FiEye,
  FiChevronLeft,
  FiChevronRight,
  FiClipboard,
  FiX,
  FiFileText,
  FiDownload,
  FiFile,
} from "react-icons/fi";
import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { debounce } from "lodash";

const API_HOST = process.env.REACT_APP_API_URL;
const cookies = new Cookies();

const Ordenes = () => {
  // Estados
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchTermCliente, setSearchTermCliente] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [errors, setErrors] = useState({});
  const [selectedItem, setSelectedItem] = useState(null);
  const [clientes, setClientes] = useState([]);
  const [paquetes, setPaquetes] = useState([]);
  const [selectedPaquetes, setSelectedPaquetes] = useState([]);
  const [paqueteSeleccionado, setPaqueteSeleccionado] = useState("");
  const [tasaCambio, setTasaCambio] = useState(0);
  const [loading, setLoading] = useState(true);
  const [numeroOrdenUpdate, setNumeroOrdenUpdate] = useState("");
  const [trackingSeleccionado, setTrackingSeleccionado] = useState("");
  const [pesoRedondeado, setPesoRedondeado] = useState(null);
  const [redondeo, setRedondeo] = useState({
    tipo: null, // 'arriba' | 'abajo'
    paqueteId: null,
    diferencia: 0,
  });
  const [formData, setFormData] = useState({
    idCliente: "",
    estado: "No Pagado",
  });

  const [redondeoAplicado, setRedondeoAplicado] = useState({
    paqueteId: null,
    diferencia: 0,
  });

  const [editingId, setEditingId] = useState(null);
  const itemsPerPageOptions = [5, 10, 20, 50];
  // Agrega este efecto
  useEffect(() => {
    setPesoRedondeado(null);
  }, [selectedPaquetes]);
  // Efectos
  useEffect(() => {
    const fetchAllData = async () => {
      setLoading(true);

      try {
        await fetchData();
        setLoading(false);
        await Promise.all([
          fetchClientes(),
          fetchPaquetes(),
          fetchTasaCambio(),
        ]);
      } catch (error) {
        console.error("Error fetching data:", error);
        Swal.fire("Error", "No se pudieron cargar los datos", "error");
      }
    };

    fetchAllData();
  }, []);

  useEffect(() => {
    fetchPaquetes();
  }, [data]);

  useEffect(() => {
    filterData();
  }, [searchTerm, data]);

  // Funciones de fetching de datos
  const fetchData = async () => {
    const bearertoken = cookies.get("token");

    try {
      const [ordenesResponse, ordenesPaquetesResponse] = await Promise.all([
        fetch(`${API_HOST}/ordenes`, {
          headers: {
            Authorization: `Bearer ${bearertoken}`,
            API: "457896",
          },
        }),
        fetch(`${API_HOST}/ordenPaquetes`, {
          headers: {
            Authorization: `Bearer ${bearertoken}`,
            API: "457896",
          },
        }),
      ]);

      const ordenes = await ordenesResponse.json();
      const ordenesPaquetes = await ordenesPaquetesResponse.json();

      // Procesamiento combinado de datos
      const ordenesAgrupadas = ordenesPaquetes.map((op) => {
        const paquetesOrden = ordenes.filter(
          (o) => o.numeroOrden === op.numeroOrden
        );

        console.log(op);
        return {
          idOrden: op.idOrdenesPaquetes,
          numeroOrden: op.numeroOrden,
          idCliente: op.idCliente,
          estado: op.estado,
          cliente: op.cliente,
          costoPorManejo: op.costoPorManejo,
          paquetes: paquetesOrden.map((po) => ({
            ...po.paquetes,
            costoPorLibra: parseFloat(po.costoPorLibra || 0),
            costoPersonalizado: po.costoPersonalizado
              ? parseFloat(po.costoPersonalizado)
              : null,
            total: parseFloat(po.total || 0),
            isv: parseFloat(po.isv || 0),
            subtotal: parseFloat(po.subtotal || 0),
            descuento: parseFloat(po.descuento || 0),
          })),
          total: paquetesOrden
            .reduce((sum, po) => sum + parseFloat(po.total || 0), 0)
            .toFixed(2),
          subtotal: paquetesOrden
            .reduce((sum, po) => sum + parseFloat(po.subtotal || 0), 0)
            .toFixed(2),
          totalISV: paquetesOrden
            .reduce((sum, po) => sum + parseFloat(po.isv || 0), 0)
            .toFixed(2),
          descuento: paquetesOrden
            .reduce((sum, po) => sum + parseFloat(po.descuento || 0), 0)
            .toFixed(2),
        };
      });

      setData(ordenesAgrupadas);
      setFilteredData(ordenesAgrupadas);
    } catch (error) {
      console.error("Error fetching orders:", error);
      throw error;
    }
  };

  const calcularTotalesConPaquetes = (paquetes) => {
    // Calcular subtotal sumando todos los subtotales de paquetes
    const subtotal = paquetes.reduce((sum, p) => sum + (p.subtotal || 0), 0);

    // Calcular descuento (se aplica al subtotal ANTES del ISV)
    const { porcentaje: descuentoPorcentaje, valor: descuento } =
      calcularDescuento();
    const subtotalConDescuento = subtotal - descuento;

    // Calcular ISV sobre el subtotal con descuento
    const isv = subtotalConDescuento * 0.15;

    // Calcular total final
    const total = subtotalConDescuento + isv;

    return {
      subtotal, // Subtotal sin descuento ni ISV
      subtotalConDescuento, // Subtotal después de descuento
      isv, // ISV calculado sobre subtotal con descuento
      descuentoPorcentaje: descuentoPorcentaje,
      descuento, // Monto del descuento aplicado
      total, // Total a pagar (subtotalConDescuento + ISV)
    };
  };

  const fetchClientes = async () => {
    const bearertoken = cookies.get("token");

    try {
      const response = await fetch(
        `${API_HOST}/clientes?export=true&search=${searchTermCliente}`,
        {
          headers: {
            Authorization: `Bearer ${bearertoken}`,
            API: "457896",
          },
        }
      );
      const result = await response.json();
      setClientes(result);
    } catch (error) {
      console.error("Error fetching clientes:", error);
      throw error;
    }
  };

  const fetchPaquetes = async () => {
    const bearertoken = cookies.get("token");

    try {
      const response = await fetch(`${API_HOST}/paquetes/estado`, {
        headers: {
          Authorization: `Bearer ${bearertoken}`,
          API: "457896",
        },
      });
      const result = await response.json();
      setPaquetes(result);
    } catch (error) {
      console.error("Error fetching paquetes:", error);
      throw error;
    }
  };

  // Calcula el peso consolidado
  const pesoConsolidado = selectedPaquetes.reduce(
    (sum, p) => sum + (p.pesoMbox || 0),
    0
  );

  // Función mejorada de redondeo
  const redondearPeso = (tipo) => {
    const pesoActual = selectedPaquetes.reduce((sum, p) => sum + p.pesoMbox, 0);
    const valorRedondeado =
      tipo === "arriba" ? Math.ceil(pesoActual) : Math.floor(pesoActual);
    const diferencia = valorRedondeado - pesoActual;

    // 1. Buscar paquetes con decimales (.3, .7, etc.)
    const paquetesConDecimales = selectedPaquetes.filter(
      (p) => p.pesoMbox % 1 !== 0
    );

    // 2. Ordenar por proximidad al redondeo (el más cercano primero)
    const paquetesPrioritarios = [
      ...(paquetesConDecimales.length
        ? paquetesConDecimales
        : selectedPaquetes),
    ].sort((a, b) => {
      const decimalA = a.pesoMbox % 1;
      const decimalB = b.pesoMbox % 1;
      return tipo === "arriba"
        ? decimalB - decimalA // Para redondear arriba, prioriza mayores decimales
        : decimalA - decimalB; // Para redondear abajo, prioriza menores decimales
    });

    // 3. Encontrar el paquete más adecuado
    let paqueteAjustado = null;
    for (const p of paquetesPrioritarios) {
      if (p.pesoMbox + diferencia > 0) {
        // Evitar pesos negativos
        paqueteAjustado = p;
        break;
      }
    }

    if (!paqueteAjustado) paqueteAjustado = paquetesPrioritarios[0];

    // 4. Aplicar el ajuste y recalcular TODOS los costos
    const nuevosPaquetes = selectedPaquetes.map((p, index) => {
      if (p.idPaquete === paqueteAjustado.idPaquete) {
        const nuevoPeso = +(p.pesoMbox + diferencia).toFixed(2);
        const costoPorLibra =
          p.tipoEnvio === "Marítimo" ? 3.0 : p.origen === "MÉXICO" ? 7.7 : 4.7;
        const descuento =
          clientes.find((c) => c.idCliente === formData.idCliente)
            ?.tipoClienteInfo?.descuento || 0;

        // Determina si es el primer paquete del array
        const esPrimerPaquete = index === 0;
        const calculo = calcularCostoPaquete(
          { ...p, pesoMbox: nuevoPeso },
          costoPorLibra,
          descuento,
          nuevoPeso,
          esPrimerPaquete // Pasa el parámetro adicional
        );

        return {
          ...p,
          pesoMbox: nuevoPeso,
          ...calculo,
        };
      }
      return p;
    });

    setSelectedPaquetes(nuevosPaquetes);
    setRedondeo({
      tipo,
      paqueteId: paqueteAjustado.idPaquete,
      diferencia,
    });
  };

  const fetchTasaCambio = async () => {
    const bearertoken = cookies.get("token");

    try {
      const response = await fetch(`${API_HOST}/tasaCambio`, {
        headers: {
          Authorization: `Bearer ${bearertoken}`,
          API: "457896",
        },
      });
      const result = await response.json();
      if (result.length > 0) {
        setTasaCambio(result[result.length - 1].tasa);
      }
    } catch (error) {
      console.error("Error fetching tasa de cambio:", error);
      throw error;
    }
  };
  const debouncedFetchClientes = debounce(async () => {
    if (searchTermCliente.length > 2) {
      // Solo buscar si tiene al menos 3 caracteres
      await fetchClientes();
    }
  }, 500);

  const validateSelectedCliente = () => {
    const selected = clientes.find(
      (cliente) =>
        `${cliente.nombre} (${
          cliente.tipoClienteInfo?.descuento || 0
        }% desc)` === searchTermCliente
    );

    if (selected) {
      setFormData((prev) => ({ ...prev, idCliente: selected.idCliente }));
      setErrors((prev) => ({ ...prev, idCliente: "" }));
    } else {
      setFormData((prev) => ({ ...prev, idCliente: "" }));
      setErrors((prev) => ({
        ...prev,
        idCliente: "Seleccione un cliente válido",
      }));
    }
  };

  useEffect(() => {
    return () => {
      debouncedFetchClientes.cancel();
    };
  }, []);

  // Funciones de filtrado y paginación
  const filterData = () => {
    const filtered = data.filter(
      (item) =>
        (item.cliente?.nombre &&
          item.cliente.nombre
            .toLowerCase()
            .includes(searchTerm.toLowerCase())) ||
        item.paquetes?.some((p) =>
          p.nombre?.toLowerCase().includes(searchTerm.toLowerCase())
        ) ||
        item.estado?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.numeroOrden?.toString().includes(searchTerm)
    );
    setFilteredData(filtered);
    setCurrentPage(0);
  };

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(0);
  };

  // Funciones de validación
  const validateForm = () => {
    const newErrors = {};

    if (!formData.idCliente) {
      newErrors.idCliente = "Seleccione un cliente";
    }

    if (selectedPaquetes.length === 0) {
      newErrors.paquetes = "Seleccione al menos un paquete";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Funciones de manejo de modales
  const handleView = (item) => {
    setSelectedItem(item);
    setShowViewModal(true);
  };

  const handleCloseViewModal = () => {
    setShowViewModal(false);
  };

  const handleShowModal = (item = null) => {
    if (item) {
      setFormData({
        idCliente: item.idCliente,
        estado: item.estado,
      });

      // Asegurarnos de que los valores numéricos sean números, no strings
      const paquetesConNumeros = item.paquetes.map((p) => ({
        ...p,
        costoPorLibra:
          typeof p.costoPorLibra === "string"
            ? parseFloat(p.costoPorLibra)
            : p.costoPorLibra,
        costoPersonalizado: p.costoPersonalizado
          ? typeof p.costoPersonalizado === "string"
            ? parseFloat(p.costoPersonalizado)
            : p.costoPersonalizado
          : null,
        total: typeof p.total === "string" ? parseFloat(p.total) : p.total,
        isv: typeof p.isv === "string" ? parseFloat(p.isv) : p.isv,
        subtotal:
          typeof p.subtotal === "string" ? parseFloat(p.subtotal) : p.subtotal,
        descuento:
          typeof p.descuento === "string"
            ? parseFloat(p.descuento)
            : p.descuento,
      }));

      setSelectedPaquetes(paquetesConNumeros || []);
      setNumeroOrdenUpdate(item.numeroOrden);
      setEditingId(item.idOrden);
    } else {
      setFormData({
        idCliente: "",
        estado: "No Pagado",
      });
      setSelectedPaquetes([]);
      setEditingId(null);
    }
    setErrors({});
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  // Funciones de cálculo
  const calcularCostoPaquete = (
    paquete,
    costoPorLibra,
    descuentoPorcentaje = 0,
    peso = paquete.pesoMbox,
    esPrimerPaquete = false
  ) => {
    const costoUsar =
      paquete.costoPersonalizado !== null
        ? paquete.costoPersonalizado
        : costoPorLibra;

    const costoManejo = paquete.origen === "MÉXICO" ? 4.7 : 4.7;

    // Calcular subtotal en dólares (sin ISV ni descuento)
    const subtotalDolares = esPrimerPaquete
      ? peso * costoUsar + costoManejo
      : peso * costoUsar;

    // Aplicar descuento al subtotal (antes del ISV)
    const descuentoDolares = subtotalDolares * (descuentoPorcentaje / 100);
    const subtotalConDescuentoDolares = subtotalDolares - descuentoDolares;

    // Calcular ISV (15% del subtotal con descuento)
    const isvDolares = subtotalConDescuentoDolares * 0.15;
    const totalDolares = subtotalConDescuentoDolares + isvDolares;

    // Convertir a Lempiras (si tasaCambio está definida)
    const subtotal = subtotalConDescuentoDolares * tasaCambio;
    const isv = isvDolares * tasaCambio;
    const total = totalDolares * tasaCambio;
    const descuento = descuentoDolares * tasaCambio;

    return {
      totalDolares, // Total en dólares (con ISV)
      total, // Total en Lempiras (con ISV)
      isv, // ISV en Lempiras
      subtotal, // Subtotal en Lempiras (después de descuento, antes de ISV)
      descuento, // Descuento en Lempiras
    };
  };
  const calcularDescuento = () => {
    if (!formData.idCliente) return { porcentaje: 0, valor: 0 };

    const clienteSeleccionado = clientes.find(
      (c) => c.idCliente.toString() === formData.idCliente.toString()
    );
    if (!clienteSeleccionado || !clienteSeleccionado.tipoClienteInfo)
      return { porcentaje: 0, valor: 0 };

    const descuentoPorcentaje =
      clienteSeleccionado.tipoClienteInfo.descuento || 0;
    const descuentoValor = selectedPaquetes.reduce(
      (sum, p) => sum + (p.descuento || 0),
      0
    );

    return {
      porcentaje: descuentoPorcentaje,
      valor: descuentoValor,
    };
  };

  const calcularTotales = () => {
    let subtotal = 0;
    let isv = 0;
    let descuento = 0;
    let total = 0;

    selectedPaquetes.forEach((p, index) => {
      const esPrimerPaquete = index === 0;
      const costoPorLibra =
        p.tipoEnvio === "Marítimo" ? 3.0 : p.origen === "MÉXICO" ? 7.7 : 4.7;
      const descuentoCliente =
        clientes.find((c) => c.idCliente === formData.idCliente)
          ?.tipoClienteInfo?.descuento || 0;

      const calculo = calcularCostoPaquete(
        p,
        costoPorLibra,
        descuentoCliente,
        p.pesoMbox,
        esPrimerPaquete
      );

      subtotal += calculo.subtotal;
      isv += calculo.isv;
      descuento += calculo.descuento;
      total += calculo.total;
    });

    return {
      subtotal: +subtotal.toFixed(2),
      isv: +isv.toFixed(2),
      descuento: +descuento.toFixed(2),
      total: +total.toFixed(2),
    };
  };

  // Funciones de manejo de paquetes
  const handleAddPaquete = () => {
    if (!paqueteSeleccionado) {
      Swal.fire("Error", "Seleccione un paquete primero", "error");
      return;
    }

    const paqueteEncontrado = paquetes.find(
      (p) =>
        p.idPaquete.toString() === paqueteSeleccionado.toString() &&
        p.estado === "Listo para entrega"
    );

    if (!paqueteEncontrado) {
      Swal.fire(
        "Error",
        "Solo se pueden agregar paquetes en bodega o en tránsito",
        "error"
      );
      return;
    }

    const yaExiste = selectedPaquetes.some(
      (p) => p.idPaquete.toString() === paqueteSeleccionado.toString()
    );
    if (yaExiste) {
      Swal.fire("Error", "Este paquete ya fue agregado", "error");
      return;
    }

    const clienteSeleccionado = clientes.find(
      (c) => c.idCliente.toString() === formData.idCliente.toString()
    );
    const descuentoPorcentaje =
      clienteSeleccionado?.tipoClienteInfo?.descuento || 0;
    const costoPorLibra =
      paqueteEncontrado.tipoEnvio === "Marítimo"
        ? 3.0
        : paqueteEncontrado.origen === "MÉXICO"
        ? 7.7
        : 4.7;
    const costoCalculado = calcularCostoPaquete(
      paqueteEncontrado,
      costoPorLibra,
      descuentoPorcentaje
    );

    setSelectedPaquetes((prev) => [
      ...prev,
      {
        ...paqueteEncontrado,
        costoPorLibra,
        costoPersonalizado: null,
        ...costoCalculado,
      },
    ]);

    setPaqueteSeleccionado("");
  };

  const handleRemovePaquete = (idPaquete) => {
    setSelectedPaquetes(
      selectedPaquetes.filter(
        (p) => p.idPaquete.toString() !== idPaquete.toString()
      )
    );
  };

  const handleUpdatePaqueteCosto = (idPaquete, costoPersonalizado) => {
    const clienteSeleccionado = clientes.find(
      (c) => c.idCliente.toString() === formData.idCliente.toString()
    );
    const descuentoPorcentaje =
      clienteSeleccionado?.tipoClienteInfo?.descuento || 0;

    setSelectedPaquetes(
      selectedPaquetes.map((p, index) => {
        const esPrimerPaquete = index === 0;

        if (p.idPaquete.toString() === idPaquete.toString()) {
          const costoPorLibra =
            p.tipoEnvio === "Marítimo"
              ? 3.0
              : p.origen === "MÉXICO"
              ? 7.7
              : 4.7;

          const costoCalculado = calcularCostoPaquete(
            {
              ...p,
              costoPersonalizado:
                costoPersonalizado !== ""
                  ? parseFloat(costoPersonalizado)
                  : null,
            },
            costoPorLibra,
            descuentoPorcentaje,
            p.pesoMbox,
            esPrimerPaquete
          );

          return {
            ...p,
            costoPersonalizado:
              costoPersonalizado !== "" ? parseFloat(costoPersonalizado) : null,
            ...costoCalculado,
          };
        }

        return p;
      })
    );
  };

  // Funciones CRUD
  const handleSubmit = async () => {
    const bearertoken = cookies.get("token");

    if (!validateForm()) {
      Swal.fire(
        "Error",
        "Por favor corrija los errores en el formulario",
        "error"
      );
      return;
    }

    const method = editingId ? "PUT" : "POST";
    const url = editingId ? `/ordenes/${editingId}` : "/ordenes";

    const { subtotal, isv, descuento, total } =
      calcularTotalesConPaquetes(selectedPaquetes);

    const dataToSubmit = {
      ...formData,
      paquetes: selectedPaquetes.map((p) => ({
        idPaquete: p.idPaquete,
        costoPorLibra: p.costoPorLibra.toFixed(2),
        costoPersonalizado: p.costoPersonalizado
          ? p.costoPersonalizado.toFixed(2)
          : null,
        total: p.total.toFixed(2),
        isv: p.isv.toFixed(2),
        subtotal: p.subtotal.toFixed(2),
        descuento: p.descuento.toFixed(2),
      })),
      numeroOrden: numeroOrdenUpdate,
      subtotal: subtotal.toFixed(2),
      totalISV: isv.toFixed(2),
      descuento: descuento.toFixed(2),
      total: total.toFixed(2),
    };

    try {
      const response = await fetch(`${API_HOST}${url}`, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${bearertoken}`,
          API: "457896",
        },
        body: JSON.stringify(dataToSubmit),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Error en la solicitud");
      }

      Swal.fire(
        "Éxito",
        editingId
          ? "Orden actualizada correctamente"
          : "Orden creada correctamente",
        "success"
      );
      fetchData();
      handleCloseModal();
    } catch (error) {
      Swal.fire(
        "Error",
        error.message || "Hubo un problema al procesar la orden",
        "error"
      );
    }
  };

  const handleDelete = async (id) => {
    const bearertoken = cookies.get("token");

    Swal.fire({
      title: "¿Estás seguro?",
      text: "No podrás revertir esta acción!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await fetch(`${API_HOST}/ordenes/${id}`, {
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${bearertoken}`,
              API: "457896",
            },
          });
          Swal.fire("Eliminada!", "La orden ha sido eliminada.", "success");
          fetchData();
        } catch (error) {
          Swal.fire("Error", "No se pudo eliminar la orden", "error");
        }
      }
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    // Limpiar errores del campo cuando se modifica
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: null,
      });
    }

    // Si cambia el cliente, recalcular descuentos para todos los paquetes
    if (name === "idCliente") {
      const clienteSeleccionado = clientes.find(
        (c) => c.idCliente.toString() === value.toString()
      );
      const descuentoPorcentaje =
        clienteSeleccionado?.tipoClienteInfo?.descuento || 0;

      setSelectedPaquetes((prev) =>
        prev.map((p) => {
          const costoPorLibra =
            p.tipoEnvio.toLowerCase() === "Marítimo" ? 3.0 : 4.7;
          const costoCalculado = calcularCostoPaquete(
            {
              ...p,
              costoPersonalizado: p.costoPersonalizado,
            },
            costoPorLibra,
            descuentoPorcentaje
          );

          return {
            ...p,
            ...costoCalculado,
          };
        })
      );
    }
  };

  // Funciones de utilidad
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    };
    return new Date(dateString).toLocaleDateString("es-ES", options);
  };

  const getEstadoBadge = (estado) => {
    const variant =
      {
        "No Pagado": "danger",
        Facturado: "success",
        "Entregado - No Pagado": "warning",
        Completado: "primary",
        Cancelado: "secondary",
      }[estado] || "light";

    return <Badge bg={variant}>{estado}</Badge>;
  };

  // Cálculo de totales para el modal
  const { subtotal, isv, descuentoPorcentaje, descuento, total } =
    calcularTotales();

  // Datos paginados
  const pageCount = Math.ceil(filteredData.length / itemsPerPage);
  const displayedData = filteredData.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  if (loading) {
    return (
      <div className='container-fluid mt-4'>
        <div
          className='d-flex justify-content-center align-items-center'
          style={{ height: "300px" }}
        >
          <Spinner animation='border' role='status'>
            <span className='visually-hidden'>Cargando...</span>
          </Spinner>
        </div>
      </div>
    );
  }

  const copiarYAlertar = () => {
    if (!selectedItem) return;

    const cliente = selectedItem.cliente || {};
    const tipoCliente = cliente.tipoClienteInfo || {};
    const paquetes = selectedItem.paquetes || [];

    // Generar el texto
    let texto = `¡Hola ${cliente.nombre || "cliente"}! 👋\n\n`;
    texto += `Nos complace informarle que su/sus paquetes han llegado a nuestras instalaciones y están disponibles para retiro en nuestra oficina.\n\n`;
    texto += `📦 *Detalles de la Orden*\n\n`;
    texto += `🧾 *Número de Orden:* ${selectedItem.numeroOrden}\n`;
    texto += `📌 *Estado:* ${selectedItem.estado}\n\n`;

    texto += `👤 *Información del Cliente*\n`;
    texto += `• Nombre: ${cliente.nombre || "N/A"}\n`;
    texto += `• Tipo: ${tipoCliente.nombreTipoCliente || "N/A"} (${
      tipoCliente.descuento || 0
    }% desc)\n`;
    texto += `• Identidad: ${cliente.identidad || "N/A"}\n`;
    texto += `• Teléfono: ${cliente.telefono || "N/A"}\n\n`;

    texto += `📦 *Paquetes (${paquetes.length})*\n`;
    paquetes.forEach((p, i) => {
      texto += `\n#${i + 1} Tracking: ${p.tracking}\n`;
      texto += `• Tipo: ${p.tipoEnvio}, Peso: ${p.pesoMbox} lbs\n`;
      texto += `• Costo por libra: L. ${
        p.costoPersonalizado
          ? `${Number(p.costoPersonalizado).toFixed(2)} (personalizado)`
          : `${Number(p.costoPorLibra).toFixed(2)} ${
              p.tipoEnvio === "Marítimo" ? "(Marítimo)" : "(aéreo)"
            }`
      }\n`;
      /* texto += `• Subtotal: L. ${Number(p.subtotal || 0).toFixed(2)}\n`;
      texto += `• ISV (15%): L. ${Number(p.isv || 0).toFixed(2)}\n`;
      texto += `• Descuento: -L. ${Number(p.descuento || 0).toFixed(2)}\n`;
      texto += `• Total: L. ${Number(p.total || 0).toFixed(2)}\n`;*/
    });

    texto += `\n🧾 *Resumen Final*\n`;

    texto += `• Subtotal sin Descuento: L. ${(Number(selectedItem.subtotal || 0) + Number(selectedItem.descuento || 0)).toFixed(2)}\n`;
    
    texto += `• Descuento: -L. ${Number(selectedItem.descuento || 0).toFixed(
      2
    )}\n`;

    texto += `• Subtotal con Descuento: L. ${Number(selectedItem.subtotal || 0).toFixed(
      2
    )}\n`;
    
    texto += `• ISV (15%): L. ${Number(selectedItem.totalISV || 0).toFixed(
      2
    )}\n`;
    
    texto += `• Total: L. ${Number(selectedItem.total || 0).toFixed(2)}\n`;

    texto += `💳 *Opciones de Pago:*\n`;
    texto += `• Depósito o transferencia bancaria: Banpais, cuenta de cheques en lempiras No. 015990021465 a nombre de MBOX S DE RL DE CV.\n`;
    texto += `• Pago con tarjeta o en efectivo: Directamente en nuestra oficina.\n`;
    texto += `• Depósito o transferencia bancaria: BAC, Cuenta Ahorros No. 755471461 a nombre de ANA KARINA CUELLAR\n`;

    texto += `*⚠️ Recordatorio Importante:*\n`;
    texto += `*El costo por manejo de aduanas se aplica por factura, no por paquete individual y el monto es por 4.70$.*\n\n`;

    // Información adicional
    texto += `\n📅 *Horario de Atención:*\n`;
    texto += `• Lunes a Viernes: 8:00 AM a 5:00 PM\n`;
    texto += `• Sábados: 9:00 AM a 12:00 PM\n\n`;
    texto += `Agradecemos su preferencia y estamos a su disposición para cualquier consulta adicional.\n\n`;
    texto += `Atentamente,\n`;
    texto += `MBOX S DE RL DE CV\n`;
    texto += `Blvrd C. América Edificio Corporativo C.A Local 5 Piso 3\n\n`;

    // Copiar al portapapeles y mostrar la alerta
    navigator.clipboard
      .writeText(texto)
      .then(() => {
        // Alerta de éxito
        Swal.fire({
          title: "¡Copiado al portapapeles!",
          text: "El texto ha sido copiado y ahora puedes enviarlo por WhatsApp.",
          icon: "success",
          confirmButtonText: "¡Listo!",
        });
      })
      .catch((err) => {
        // Mostrar error si no se pudo copiar
        Swal.fire({
          title: "Error",
          text: "Hubo un problema al copiar la información.",
          icon: "error",
          confirmButtonText: "Inténtalo de nuevo",
        });
      });
  };

  const exportToExcel = () => {
    // Preparar los datos con formato adecuado para órdenes
    const excelData = filteredData.map((item) => ({
      "# PreFactura": item.numeroOrden,
      Cliente: item.cliente?.nombre || "N/A",
      "Tipo Cliente": item.cliente?.tipoClienteInfo?.nombreTipoCliente || "N/A",
      "Cantidad Paquetes": item.paquetes?.length || 0,
      Estado: item.estado,
      "Subtotal (L)": item.subtotal || "0.00",
      "ISV (15%) (L)": item.totalISV || "0.00",
      "Descuento (L)": item.descuento || "0.00",
      "Total (L)": item.total || "0.00",
      "Fecha Creación": item.createdAt
        ? new Date(item.createdAt).toLocaleDateString("es-ES")
        : "N/A",
      "Última Actualización": item.updatedAt
        ? new Date(item.updatedAt).toLocaleDateString("es-ES")
        : "N/A",
    }));

    // Crear libro de trabajo y hoja
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(excelData);

    // Añadir hoja al libro
    XLSX.utils.book_append_sheet(workbook, worksheet, "Órdenes");

    // Establecer anchos de columnas (en caracteres)
    const colWidths = [
      { wch: 15 }, // # PreFactura
      { wch: 25 }, // Cliente
      { wch: 15 }, // Tipo Cliente
      { wch: 10 }, // Cantidad Paquetes
      { wch: 15 }, // Estado
      { wch: 12 }, // Subtotal
      { wch: 12 }, // ISV
      { wch: 12 }, // Descuento
      { wch: 12 }, // Total
      { wch: 15 }, // Fecha Creación
      { wch: 15 }, // Última Actualización
    ];
    worksheet["!cols"] = colWidths;

    // Aplicar estilos a los encabezados
    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "2c3e50" } }, // Color azul oscuro
      alignment: { horizontal: "center" },
      border: {
        top: { style: "thin", color: { rgb: "1a1a1a" } },
        bottom: { style: "thin", color: { rgb: "1a1a1a" } },
        left: { style: "thin", color: { rgb: "1a1a1a" } },
        right: { style: "thin", color: { rgb: "1a1a1a" } },
      },
    };

    // Aplicar estilos a todas las celdas
    const range = XLSX.utils.decode_range(worksheet["!ref"]);
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const headerCell = XLSX.utils.encode_cell({ r: range.s.r, c: C });

      // Aplicar estilo al encabezado
      if (!worksheet[headerCell].s) worksheet[headerCell].s = {};
      Object.assign(worksheet[headerCell].s, headerStyle);

      // Aplicar bordes a todas las celdas
      for (let R = range.s.r + 1; R <= range.e.r; ++R) {
        const cell = XLSX.utils.encode_cell({ r: R, c: C });
        if (!worksheet[cell]) continue;
        if (!worksheet[cell].s) worksheet[cell].s = {};
        worksheet[cell].s.border = {
          top: { style: "thin", color: { rgb: "e0e0e0" } },
          bottom: { style: "thin", color: { rgb: "e0e0e0" } },
          left: { style: "thin", color: { rgb: "e0e0e0" } },
          right: { style: "thin", color: { rgb: "e0e0e0" } },
        };

        // Alinear texto al centro para columnas específicas
        if ([0, 2, 3, 4, 5, 6, 7, 8, 9, 10].includes(C)) {
          worksheet[cell].s.alignment = { horizontal: "center" };
        }
      }
    }

    // Añadir título y metadatos
    const title = "Listado de Órdenes";
    const company = "MBOX";
    const date = new Date().toLocaleDateString("es-ES", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });

    // Crear hoja para metadatos
    const infoSheet = XLSX.utils.aoa_to_sheet([
      [title],
      [""],
      [`Empresa: ${company}`],
      [`Fecha de exportación: ${date}`],
      [`Total órdenes: ${filteredData.length}`],
      [""],
    ]);

    // Formato hoja de metadatos
    infoSheet["A1"].s = { font: { bold: true, size: 16 } };
    infoSheet["A3"].s = { font: { italic: true } };
    infoSheet["A4"].s = { font: { italic: true } };
    infoSheet["A5"].s = { font: { bold: true } };

    // Añadir hoja de metadatos al libro
    XLSX.utils.book_append_sheet(workbook, infoSheet, "Informe");

    // Generar el archivo Excel
    XLSX.writeFile(
      workbook,
      `Ordenes_${new Date().toISOString().slice(0, 10)}.xlsx`
    );
  };

  const exportToPDF = () => {
    const doc = new jsPDF({
      orientation: "landscape",
    });

    // Título
    doc.setFontSize(18);
    doc.text("Listado de Órdenes", 14, 15);

    // Fecha de exportación
    doc.setFontSize(10);
    doc.text(`Exportado: ${new Date().toLocaleString()}`, 14, 22);

    // Información resumida
    doc.setFontSize(10);
    doc.text(
      `Total órdenes: ${filteredData.length}`,
      doc.internal.pageSize.width - 60,
      22
    );

    // Tabla
    autoTable(doc, {
      head: [
        [
          "# PreFactura",
          "Cliente",
          "Estado",
          "Paquetes",
          "Subtotal (L)",
          "ISV (L)",
          "Descuento (L)",
          "Total (L)",
        ],
      ],
      body: filteredData.map((item) => [
        item.numeroOrden,
        item.cliente?.nombre || "N/A",
        item.estado,
        item.paquetes?.length || 0,
        item.subtotal || "0.00",
        item.totalISV || "0.00",
        item.descuento || "0.00",
        item.total || "0.00",
      ]),
      startY: 25,
      styles: {
        fontSize: 8,
        cellPadding: 2,
        overflow: "linebreak",
      },
      headStyles: {
        fillColor: [41, 128, 185],
        textColor: 255,
        fontStyle: "bold",
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245],
      },
      tableWidth: "auto",
      margin: { left: 10, right: 10, top: 25 },
    });

    // Pie de página
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.text(
        `Página ${i} de ${pageCount}`,
        doc.internal.pageSize.width - 25,
        doc.internal.pageSize.height - 5
      );
    }

    doc.save("ordenes.pdf");
  };

  const updateOrdenStatus = async (idOrden, nuevoEstado) => {
    const bearertoken = cookies.get("token");
    try {
      const response = await fetch(`${API_HOST}/ordenPaquetes/${idOrden}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${bearertoken}`,
          API: "457896",
        },
        body: JSON.stringify({
          estado: nuevoEstado,
        }),
      });

      if (!response.ok) {
        throw new Error("Error al actualizar el estado de la factura");
      }

      return true;
    } catch (error) {
      console.error("Error updating invoice status:", error);
      return false;
    }
  };

  const updateCostoPorManejo = async (idOrden, nuevoEstado) => {
    const bearertoken = cookies.get("token");
    try {
      const response = await fetch(
        `${API_HOST}/ordenPaquetes/ordenPorManejo/${idOrden}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${bearertoken}`,
            API: "457896",
          },
          body: JSON.stringify({
            costoPorManejo: nuevoEstado,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Error al actualizar el estado de la factura");
      }

      return true;
    } catch (error) {
      console.error("Error updating invoice status:", error);
      return false;
    }
  };

  const handleStatusChange = async (orden) => {
    Swal.fire({
      title: `¿Cambiar estado a "Entragado - No pagado"?`,
      text: `Estás a punto de cambiar el estado de la orden ${
        orden.numeroOrden || orden.id
      } a Entregado - No Pagado`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, cambiar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          // Aquí llamarías a tu función para actualizar el estado de la orden
          const success = await updateOrdenStatus(
            orden.idOrden,
            "Entregado - No Pagado"
          );

          if (success) {
            Swal.fire(
              "Estado actualizado!",
              `El estado de la orden ha sido cambiado a Entregado - No Pagado.`,
              "success"
            );
            fetchData(); // Refrescar los datos
          } else {
            Swal.fire(
              "Error",
              "No se pudo cambiar el estado de la orden",
              "error"
            );
          }
        } catch (error) {
          console.error("Error al cambiar estado:", error);
          Swal.fire(
            "Error",
            "Ocurrió un error al intentar cambiar el estado",
            "error"
          );
        }
      }
    });
  };
  const handleCostoPorManejoChange = async (orden) => {
    // Verificar si el estado es "Facturado"
    if (orden.estado === "Facturado") {
      Swal.fire({
        title: "Acción no permitida",
        text: "No se puede modificar el Costo por Manejo en órdenes facturadas",
        icon: "info",
        confirmButtonText: "Entendido",
      });
      return; // Salir de la función sin hacer nada más
    }

    const nuevoValor = !orden.costoPorManejo; // Invierte el valor actual

    Swal.fire({
      title: `¿Cambiar Costo por Manejo a ${nuevoValor ? "Sí" : "No"}?`,
      text: `Estás a punto de cambiar el Costo Por Manejo de la orden ${
        orden.numeroOrden || orden.id
      } a ${nuevoValor ? "Sí" : "No"}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: `Sí, cambiar a ${nuevoValor ? "Sí" : "No"}`,
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          // Aquí debes llamar a tu API para actualizar el costoPorManejo
          const success = await updateCostoPorManejo(
            orden.idOrden, // o el identificador correcto
            nuevoValor
          );

          if (success) {
            Swal.fire(
              "¡Actualizado!",
              `El Costo por Manejo ha sido cambiado a ${
                nuevoValor ? "Sí" : "No"
              }.`,
              "success"
            );
            fetchData(); // Refrescar los datos
          } else {
            Swal.fire(
              "Error",
              "No se pudo cambiar el Costo por Manejo",
              "error"
            );
          }
        } catch (error) {
          console.error("Error al cambiar Costo por Manejo:", error);
          Swal.fire(
            "Error",
            "Ocurrió un error al intentar cambiar el Costo por Manejo",
            "error"
          );
        }
      }
    });
  };

  return (
    <div className='container-fluid mt-4'>
      <div className='card border-0 shadow-sm'>
        <div className='card-body'>
          <div className='d-flex justify-content-between mb-4'>
            <h5 className='card-title mb-0'>Gestión de Ordenes(PreFacturas)</h5>
            <div>
              <Dropdown className='d-inline me-2'>
                <Dropdown.Toggle variant='outline-primary' size='sm'>
                  <FiDownload className='me-1' /> Exportar
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={exportToExcel}>
                    <FiFileText className='me-2' /> Excel (.xlsx)
                  </Dropdown.Item>
                  <Dropdown.Item onClick={exportToPDF}>
                    <FiFile className='me-2' /> PDF (.pdf)
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <Button
                variant='success'
                onClick={() => handleShowModal()}
                size='sm'
              >
                Agregar Nuevo
              </Button>
            </div>
          </div>
          <div className='d-flex justify-content-between mb-3'>
            <Form.Control
              type='text'
              placeholder='Buscar por cliente o estado...'
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ width: "70%" }}
              className='border'
            />
            <div className='d-flex align-items-center'>
              <span className='me-2 text-muted'>Mostrar:</span>
              <Form.Select
                value={itemsPerPage}
                onChange={handleItemsPerPageChange}
                style={{ width: "80px" }}
                className='border'
                size='sm'
              >
                {itemsPerPageOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </Form.Select>
            </div>
          </div>

          <div className='table-responsive'>
            <Table hover className='mb-0'>
              <thead>
                <tr>
                  <th className='border-top-0'># PreFactura</th>
                  <th className='border-top-0'>Cliente</th>
                  <th className='border-top-0'>Paquetes</th>
                  <th className='border-top-0'>Estado</th>
                  <th className='border-top-0'>Costo Por Manejo</th>
                  <th className='border-top-0'>Total</th>
                  <th className='border-top-0 text-end'>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {displayedData.map((item) => (
                  <tr key={item.idOrden}>
                    <td className='fw-medium'>{item.numeroOrden}</td>
                    <td>{item.cliente?.nombre || "N/A"}</td>
                    <td>
                      {item.paquetes?.length > 0 ? (
                        <small>
                          {item.paquetes.length} paquete
                          {item.paquetes.length !== 1 ? "s" : ""}
                        </small>
                      ) : (
                        "N/A"
                      )}
                    </td>
                    <td
                      onClick={() => handleStatusChange(item)}
                      style={{ cursor: "pointer" }}
                    >
                      {getEstadoBadge(item.estado)}
                    </td>
                    <td
                      onClick={() => handleCostoPorManejoChange(item)}
                      style={{ cursor: "pointer" }}
                    >
                      {item.costoPorManejo ? (
                        <span className='badge bg-success'>Sí</span>
                      ) : (
                        <span className='badge bg-danger'>No</span>
                      )}
                    </td>
                    <td>L. {item.total || "0.00"}</td>
                    <td className='text-end'>
                      <Button
                        variant='outline-warning'
                        onClick={() => handleShowModal(item)}
                        className='me-2'
                        title='Editar'
                        size='sm'
                      >
                        <FiEdit />
                      </Button>
                      <Button
                        variant='outline-danger'
                        onClick={() => handleDelete(item.numeroOrden)}
                        className='me-2 action-btn'
                        title='Eliminar'
                        size='sm'
                      >
                        <FiTrash />
                      </Button>
                      <Button
                        variant='outline-primary'
                        onClick={() => handleView(item)}
                        title='Ver detalles'
                        size='sm'
                      >
                        <FiEye />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>

          <div className='d-flex justify-content-between align-items-center mt-3'>
            <div className='text-muted small'>
              Mostrando {displayedData.length} de {filteredData.length}{" "}
              registros
            </div>
            <ReactPaginate
              previousLabel={<FiChevronLeft size={14} />}
              nextLabel={<FiChevronRight size={14} />}
              pageCount={pageCount}
              onPageChange={handlePageClick}
              containerClassName={"pagination mb-0"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              activeClassName={"active"}
              breakLabel='...'
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
            />
          </div>
        </div>
      </div>

      {/* Modal para crear/editar órdenes */}
      <Modal show={showModal} onHide={handleCloseModal} centered size='lg'>
        <Modal.Header closeButton className='border-bottom'>
          <Modal.Title>{editingId ? "Editar" : "Nueva"} Orden</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row className='mb-3'>
              <Col md={12}>
                <Form.Group>
                  <Form.Label>
                    <span className='text-danger'>*</span> Cliente
                  </Form.Label>
                  <Form.Control
                    list='clientes-list'
                    type='text'
                    name='clienteSearch'
                    value={searchTermCliente}
                    onChange={(e) => {
                      setSearchTermCliente(e.target.value);
                      // Opcional: agregar debounce para evitar muchas llamadas
                      debouncedFetchClientes();
                    }}
                    onBlur={() => {
                      // Validar que el cliente seleccionado exista en la lista
                      validateSelectedCliente();
                    }}
                    isInvalid={!!errors.idCliente}
                    className='border'
                    placeholder='Escribe para buscar cliente...'
                  />
                  <datalist id='clientes-list'>
                    {clientes.map((cliente) => (
                      <option
                        key={cliente.idCliente}
                        value={`${cliente.nombre} (${
                          cliente.tipoClienteInfo?.descuento || 0
                        }% desc)`}
                        data-id={cliente.idCliente}
                      />
                    ))}
                  </datalist>
                  <Form.Control
                    type='hidden'
                    name='idCliente'
                    value={formData.idCliente}
                    onChange={handleChange}
                  />
                  <Form.Control.Feedback type='invalid'>
                    {errors.idCliente}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row className='mb-3'>
              <Col md={12}>
                <Form.Group>
                  <Form.Label>
                    <span className='text-danger'>*</span> Paquetes
                  </Form.Label>
                  <div className='d-flex mb-2'>
                    <div className='position-relative flex-grow-1 me-2'>
                      <Form.Control
                        list='paquetesList'
                        value={trackingSeleccionado}
                        onChange={(e) => {
                          const selectedTracking = e.target.value;
                          setTrackingSeleccionado(selectedTracking);
                          // Encontrar el idPaquete correspondiente
                          const paquete = paquetes.find(
                            (p) => p.tracking === selectedTracking
                          );
                          setPaqueteSeleccionado(paquete?.idPaquete || "");
                        }}
                        className='border'
                        placeholder='Buscar por número de tracking'
                      />
                      <datalist id='paquetesList'>
                        {paquetes
                          .filter(
                            (p) =>
                              !selectedPaquetes.some(
                                (sp) =>
                                  sp.idPaquete.toString() ===
                                  p.idPaquete.toString()
                              ) && p.estado === "Listo para entrega"
                          )
                          .map((paquete) => (
                            <option
                              key={paquete.idPaquete}
                              value={paquete.tracking}
                              data-id={paquete.idPaquete}
                            >
                              {paquete.tracking} - {paquete.nombre} (
                              {paquete.tipoEnvio}, {paquete.pesoMbox} lbs,{" "}
                              {paquete.estado})
                            </option>
                          ))}
                      </datalist>
                    </div>
                    <Button
                      variant='primary'
                      onClick={handleAddPaquete}
                      disabled={!paqueteSeleccionado}
                    >
                      Agregar
                    </Button>
                  </div>
                  {errors.paquetes && (
                    <div className='text-danger small mb-2'>
                      {errors.paquetes}
                    </div>
                  )}

                  <ListGroup>
                    {selectedPaquetes.map((paquete) => (
                      <ListGroup.Item key={paquete.idPaquete}>
                        <div className='d-flex justify-content-between align-items-start mb-2'>
                          <div>
                            <strong>{paquete.tracking}</strong> -{" "}
                            {paquete.nombre}
                            <div className='small'>
                              Tipo: {paquete.tipoEnvio}, Peso:{" "}
                              {paquete.pesoMbox} lbs
                            </div>
                            <div className='small'>
                              Costo por libra:{" "}
                              {paquete.costoPersonalizado !== null
                                ? `L. ${paquete.costoPersonalizado} (personalizado)`
                                : `L. ${paquete.costoPorLibra} (${
                                    paquete.tipoEnvio === "Marítimo"
                                      ? "marítimo"
                                      : "aéreo"
                                  })`}
                            </div>
                          </div>
                          <Button
                            variant='outline-danger'
                            size='sm'
                            onClick={() =>
                              handleRemovePaquete(paquete.idPaquete)
                            }
                          >
                            <FiX />
                          </Button>
                        </div>

                        <InputGroup size='sm' className='mb-2'>
                          <InputGroup.Text>Costo por libra:</InputGroup.Text>
                          <Form.Control
                            type='number'
                            step='0.01'
                            min='0'
                            value={
                              paquete.costoPersonalizado !== null
                                ? paquete.costoPersonalizado
                                : ""
                            }
                            onChange={(e) =>
                              handleUpdatePaqueteCosto(
                                paquete.idPaquete,
                                e.target.value
                              )
                            }
                            placeholder={`Usar valor por defecto (${paquete.costoPorLibra})`}
                          />
                          <Button
                            variant='outline-secondary'
                            onClick={() =>
                              handleUpdatePaqueteCosto(paquete.idPaquete, "")
                            }
                          >
                            Usar valor por defecto
                          </Button>
                        </InputGroup>

                        <div className='small d-flex justify-content-between'>
                          <span>
                            Subtotal: L.{" "}
                            {paquete.subtotal?.toFixed(2) || "0.00"}
                          </span>
                          <span>
                            ISV (15%): L. {paquete.isv?.toFixed(2) || "0.00"}
                          </span>
                          <span className='text-success'>
                            Descuento: -L.{" "}
                            {paquete.descuento?.toFixed(2) || "0.00"}
                          </span>
                          <span>
                            Total: L. {paquete.total?.toFixed(2) || "0.00"}
                          </span>
                        </div>
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                </Form.Group>
              </Col>
            </Row>
            <div className='d-flex align-items-center mb-3'>
              <span className='fw-bold me-2'>
                Peso Total: {pesoConsolidado.toFixed(1)} lbs
              </span>

              <Button
                variant='outline-success'
                size='sm'
                onClick={() => redondearPeso("arriba")}
                disabled={pesoConsolidado % 1 === 0}
                className='me-2'
              >
                ↑ Redondear a {Math.ceil(pesoConsolidado)} lbs
              </Button>

              <Button
                variant='outline-danger'
                size='sm'
                onClick={() => redondearPeso("abajo")}
                disabled={pesoConsolidado % 1 === 0}
              >
                ↓ Redondear a {Math.floor(pesoConsolidado)} lbs
              </Button>
            </div>
            <Row className='mt-3'>
              <Col md={12}>
                <div className='border-top pt-2'>
                  <div className='d-flex justify-content-between'>
                    <div className='fw-bold'>Subtotal:</div>
                    <div>L. {subtotal.toFixed(2)}</div>
                  </div>
                  <div className='d-flex justify-content-between'>
                    <div className='fw-bold'>ISV (15%):</div>
                    <div>L. {isv.toFixed(2)}</div>
                  </div>
                  <div
                    className={`d-flex justify-content-between ${
                      descuentoPorcentaje > 0 ? "text-success" : ""
                    }`}
                  >
                    <div className='fw-bold'>
                      Descuento ({descuentoPorcentaje}%):
                    </div>
                    <div>- L. {descuento.toFixed(2)}</div>
                  </div>
                  <div className='d-flex justify-content-between'>
                    <div className='fw-bold'>Total:</div>
                    <div className='fw-bold'>L. {total.toFixed(2)}</div>
                  </div>
                </div>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer className='border-top'>
          <Button variant='outline-secondary' onClick={handleCloseModal}>
            Cancelar
          </Button>
          <Button variant='primary' onClick={handleSubmit}>
            {editingId ? "Actualizar" : "Guardar"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal para ver detalles */}
      <Modal
        show={showViewModal}
        onHide={handleCloseViewModal}
        centered
        size='lg'
      >
        <Modal.Header closeButton className='border-bottom'>
          <Modal.Title>
            <FiEye className='me-2 text-primary' />
            Detalles de la Orden
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedItem && (
            <div>
              <Row>
                <Col md={6}>
                  <div className='mb-3'>
                    <h6 className='text-muted mb-2'>Información de la Orden</h6>
                    <div className='ps-3'>
                      <p className='mb-2'>
                        <span className='fw-medium'>Número:</span>{" "}
                        {selectedItem.numeroOrden}
                      </p>
                      <p className='mb-2'>
                        <span className='fw-medium'>Estado:</span>{" "}
                        {getEstadoBadge(selectedItem.estado)}
                      </p>
                    </div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className='mb-3'>
                    <h6 className='text-muted mb-2'>Información del Cliente</h6>
                    <div className='ps-3'>
                      <p className='mb-2'>
                        <span className='fw-medium'>Nombre:</span>{" "}
                        {selectedItem.cliente?.nombre || "N/A"}
                      </p>
                      <p className='mb-2'>
                        <span className='fw-medium'>Tipo:</span>{" "}
                        {selectedItem.cliente?.tipoClienteInfo
                          ?.nombreTipoCliente || "N/A"}{" "}
                        ({selectedItem.cliente?.tipoClienteInfo?.descuento || 0}
                        % desc)
                      </p>
                      <p className='mb-2'>
                        <span className='fw-medium'>Identidad:</span>{" "}
                        {selectedItem.cliente?.identidad || "N/A"}
                      </p>
                      <p className='mb-0'>
                        <span className='fw-medium'>Teléfono:</span>{" "}
                        {selectedItem.cliente?.telefono || "N/A"}
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col md={12}>
                  <div className='mb-3'>
                    <h6 className='text-muted mb-2'>
                      Paquetes ({selectedItem.paquetes?.length || 0})
                    </h6>
                    <ListGroup>
                      {selectedItem.paquetes?.map((paquete) => (
                        <ListGroup.Item key={paquete.idPaquete}>
                          <div className='d-flex justify-content-between align-items-start mb-2'>
                            <div>
                              <strong>
                                {paquete.tracking +
                                  " - " +
                                  paquete.anakel +
                                  " - " +
                                  paquete.origen}
                              </strong>

                              <div className='small'>
                                Tipo: {paquete.tipoEnvio}, Peso:{" "}
                                {paquete.pesoMbox} lbs
                              </div>
                              <div className='small'>
                                Costo por libra:{" "}
                                {paquete.costoPersonalizado
                                  ? `L. ${Number(
                                      paquete.costoPersonalizado
                                    ).toFixed(2)} (personalizado)`
                                  : `L. ${Number(paquete.costoPorLibra).toFixed(
                                      2
                                    )} (${
                                      paquete.tipoEnvio === "Marítimo"
                                        ? "marítimo"
                                        : "aéreo"
                                    })`}
                              </div>
                            </div>
                          </div>

                          <div className='small d-flex justify-content-between'>
                            <span>
                              Subtotal: L.{" "}
                              {Number(paquete.subtotal || 0).toFixed(2)}
                            </span>
                            <span>
                              ISV (15%): L.{" "}
                              {Number(paquete.isv || 0).toFixed(2)}
                            </span>
                            <span className='text-success'>
                              Descuento: -L.{" "}
                              {Number(paquete.descuento || 0).toFixed(2)}
                            </span>
                            <span>
                              Total: L. {Number(paquete.total || 0).toFixed(2)}
                            </span>
                          </div>
                        </ListGroup.Item>
                      ))}
                    </ListGroup>

                    <div className='border-top pt-2 mt-3'>
                      <div className='d-flex justify-content-between'>
                        <div className='fw-bold'>Subtotal:</div>
                        <div>
                          L. {Number(selectedItem.subtotal || 0).toFixed(2)}
                        </div>
                      </div>
                      <div className='d-flex justify-content-between'>
                        <div className='fw-bold'>ISV (15%):</div>
                        <div>
                          L. {Number(selectedItem.totalISV || 0).toFixed(2)}
                        </div>
                      </div>
                      <div
                        className={`d-flex justify-content-between ${
                          selectedItem.descuento > 0 ? "text-success" : ""
                        }`}
                      >
                        <div className='fw-bold'>
                          Descuento (
                          {selectedItem.cliente?.tipoClienteInfo?.descuento ||
                            0}
                          %):
                        </div>
                        <div>
                          - L. {Number(selectedItem.descuento || 0).toFixed(2)}
                        </div>
                      </div>
                      <div className='d-flex justify-content-between'>
                        <div className='fw-bold'>Total:</div>
                        <div className='fw-bold'>
                          L. {Number(selectedItem.total || 0).toFixed(2)}
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className='border-top'>
          <Button
            variant='outline-primary'
            onClick={copiarYAlertar}
            title='Copiar para envío por WhatsApp'
            size='sm'
          >
            <FiClipboard />{" "}
            {/* Puedes reemplazar esto por el ícono que prefieras */}
          </Button>
          <Button variant='outline-secondary' onClick={handleCloseViewModal}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Ordenes;
